import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import MarketingContainer from 'app/containers/Marketing'

const MarketingPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.marketing)}</PageTitle>
      <MarketingContainer />
    </>
  )
}
const MarketingPage = memo(MarketingPageCpn, isEqual)

export default MarketingPage
